(function () {
  'use strict';

  var SHARED_FLAVOR = 'all';
  var BOGO_RELOAD_MARKER = '_pbb_bogo_reload';

  function isEditorPreview() {
    if (
      window.Shopify &&
      window.Shopify.designMode
    ) {
      return true;
    }

    return window.self !== window.top;
  }

  function normalizeBogoParamString(rawValue) {
    if (!rawValue) return '';

    var normalized = String(rawValue).trim();
    if (!normalized) return '';

    if (normalized.indexOf('://') !== -1) {
      try {
        normalized = new URL(normalized).search.replace(/^\?/, '');
      } catch (error) {}
    }

    var queryStartIndex = normalized.indexOf('?');
    if (queryStartIndex > -1) {
      normalized = normalized.slice(queryStartIndex + 1);
    }

    normalized = normalized.replace(/^[?&]+/, '');

    var hashIndex = normalized.indexOf('#');
    if (hashIndex > -1) {
      normalized = normalized.slice(0, hashIndex);
    }

    return normalized.trim();
  }

  function getActiveBogoParams(section) {
    if (!section) return '';

    return normalizeBogoParamString(
      section.getAttribute('data-pbb-bogo-url-params') || ''
    );
  }

  function configuredBogoParamsMatchUrl(sanitizedParams) {
    var incoming = new URLSearchParams(sanitizedParams);
    var current = new URLSearchParams(window.location.search);
    var matches = true;

    incoming.forEach(function (value, key) {
      if (!key) return;

      if (current.get(key) !== value) {
        matches = false;
      }
    });

    return matches;
  }

  function mergeBogoParamsIntoUrl(baseUrl, sanitizedParams) {
    var mergedUrl = new URL(baseUrl, window.location.origin);
    var incomingParams = new URLSearchParams(sanitizedParams);
    var hasValidParam = false;

    incomingParams.forEach(function (value, key) {
      if (!key) return;

      mergedUrl.searchParams.set(key, value);
      hasValidParam = true;
    });

    return hasValidParam ? mergedUrl : null;
  }

  function stripInternalBogoParamFromCurrentUrl() {
    var url = new URL(window.location.href);

    if (!url.searchParams.has(BOGO_RELOAD_MARKER)) return;

    url.searchParams.delete(BOGO_RELOAD_MARKER);

    window.history.replaceState(
      {},
      '',
      url.pathname + (url.search || '') + url.hash
    );
  }

  function applyBogoUrlParams(section, options) {
    var sanitizedParams = getActiveBogoParams(section);
    var allowReload = !!(options && options.allowReload);

    if (isEditorPreview()) {
      return false;
    }

    if (!sanitizedParams) return false;

    if (configuredBogoParamsMatchUrl(sanitizedParams)) {
      stripInternalBogoParamFromCurrentUrl();
      return false;
    }

    var mergedUrl = mergeBogoParamsIntoUrl(
      window.location.href,
      sanitizedParams
    );

    if (!mergedUrl) return false;

    if (allowReload) {
      var currentUrl = new URL(window.location.href);

      if (!currentUrl.searchParams.has(BOGO_RELOAD_MARKER)) {
        mergedUrl.searchParams.set(BOGO_RELOAD_MARKER, '1');
        window.location.replace(mergedUrl.toString());
        return true;
      }
    }

    mergedUrl.searchParams.delete(BOGO_RELOAD_MARKER);

    window.history.replaceState(
      {},
      '',
      mergedUrl.pathname +
        (mergedUrl.search || '') +
        mergedUrl.hash
    );

    return false;
  }

  function getBogoCartAttributes(section) {
    var sanitizedParams = getActiveBogoParams(section);
    var attributes = {};
    var hasAny = false;

    if (!sanitizedParams) return null;

    new URLSearchParams(sanitizedParams).forEach(function (value, key) {
      if (!key || key === BOGO_RELOAD_MARKER) return;

      attributes[key] = value;
      hasAny = true;
    });

    return hasAny ? attributes : null;
  }

  function updateBogoCartAttributes(section) {
    var attributes = getBogoCartAttributes(section);

    if (!attributes) {
      return Promise.resolve(null);
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: attributes
      }),
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to apply BOGOS cart attributes.');
      }

      return response.json();
    });
  }

  function initBogoSubmission(section) {
    if (isEditorPreview()) {
      return;
    }

    if (
      section.getAttribute('data-pbb-bogo-submit-initialized') === 'true'
    ) {
      return;
    }

    var form = section.querySelector(
      'form[data-type="add-to-cart-form"]'
    );

    if (!form) return;

    section.setAttribute(
      'data-pbb-bogo-submit-initialized',
      'true'
    );

    form.addEventListener(
      'submit',
      function (event) {
        if (form.__pbbBogoResubmitting) {
          form.__pbbBogoResubmitting = false;
          return;
        }

        if (!getActiveBogoParams(section)) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (form.__pbbBogoPreparing) {
          return;
        }

        form.__pbbBogoPreparing = true;

        var submitter =
          event.submitter ||
          form.querySelector('[name="add"]');

        applyBogoUrlParams(section);

        updateBogoCartAttributes(section)
          .catch(function (error) {
            console.warn(
              'Product Buy Box: BOGOS cart attributes could not be applied.',
              error
            );
          })
          .then(function () {
            form.__pbbBogoPreparing = false;
            form.__pbbBogoResubmitting = true;

            if (typeof form.requestSubmit === 'function') {
              if (submitter && !submitter.disabled) {
                form.requestSubmit(submitter);
              } else {
                form.requestSubmit();
              }

              return;
            }

            form.dispatchEvent(
              new Event('submit', {
                bubbles: true,
                cancelable: true
              })
            );
          });
      },
      true
    );
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function cents(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function money(value) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents(value));
    }

    return '$' + (cents(value) / 100).toFixed(2);
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseFlavorAltText(altText) {
    var originalAlt = String(altText || '').trim();
    var parts = originalAlt.split('|');
    var groupLabel = String(parts[0] || '').trim();
    var flavorMatch = groupLabel.match(/^flavor\s*:\s*(.+)$/i);

    if (!flavorMatch) {
      return {
        flavor: SHARED_FLAVOR,
        cleanAlt: originalAlt,
        tagged: false
      };
    }

    return {
      flavor: normalizeHandle(flavorMatch[1]) || SHARED_FLAVOR,
      cleanAlt: parts.length > 1 ? parts.slice(1).join('|').trim() : '',
      tagged: true
    };
  }

  function parseJSON(element) {
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('Product Buy Box: invalid product JSON.', error);
      return null;
    }
  }

  function getProductData(section) {
    if (section.__productBuyBoxProductData) {
      return section.__productBuyBoxProductData;
    }

    var productData = parseJSON(
      section.querySelector('[data-buy-box-product-json]')
    );

    if (!productData) {
      var variantScript = section.querySelector(
        'variant-radios script[type="application/json"], ' +
        'variant-selects script[type="application/json"]'
      );

      var variants = parseJSON(variantScript);

      productData = {
        options: [],
        variants: Array.isArray(variants) ? variants : [],
        selectedVariantId: section.getAttribute('data-current-variant-id')
      };
    }

    section.__productBuyBoxProductData = productData;
    return productData;
  }

  function getVariantData(section) {
    var productData = getProductData(section);

    return productData && Array.isArray(productData.variants)
      ? productData.variants
      : [];
  }

  function getFlavorOptionIndex(section) {
    var storedIndex = parseInt(
      section.getAttribute('data-flavor-option-index'),
      10
    );

    if (Number.isFinite(storedIndex) && storedIndex >= 0) {
      return storedIndex;
    }

    var productData = getProductData(section);
    var options = productData && Array.isArray(productData.options)
      ? productData.options
      : [];

    return options.findIndex(function (optionName) {
      return String(optionName || '')
        .trim()
        .toLowerCase()
        .indexOf('flavor') !== -1;
    });
  }

  function getSelectedOptions(section) {
    var fieldsets = qsa('.product-buy-box__option-group', section);

    if (fieldsets.length) {
      return fieldsets.map(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
    }

    return qsa('variant-selects select', section).map(function (select) {
      return select.value;
    });
  }

  function findVariant(section) {
    var variants = getVariantData(section);
    var options = getSelectedOptions(section);

    if (options.length) {
      var matchedVariant = variants.find(function (variant) {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== options.length) return false;

        return variant.options.every(function (option, index) {
          return String(option) === String(options[index]);
        });
      });

      if (matchedVariant) return matchedVariant;
    }

    var currentVariantId = Number(
      section.getAttribute('data-current-variant-id')
    );

    if (!currentVariantId) {
      var productData = getProductData(section);
      currentVariantId = Number(
        productData ? productData.selectedVariantId : 0
      );
    }

    return variants.find(function (variant) {
      return Number(variant.id) === currentVariantId;
    }) || variants[0] || null;
  }

  function getVariantFlavor(section, variant) {
    var flavorOptionIndex = getFlavorOptionIndex(section);

    if (
      flavorOptionIndex < 0 ||
      !variant ||
      !Array.isArray(variant.options)
    ) {
      return '';
    }

    return normalizeHandle(variant.options[flavorOptionIndex]);
  }

  function prepareFlavorMedia(section) {
    qsa('[data-buy-box-media]', section).forEach(function (item) {
      var images = qsa('img[alt]', item);
      var firstImage = images[0] || null;
      var parsedAlt = parseFlavorAltText(
        firstImage ? firstImage.getAttribute('alt') : ''
      );
      var mediaId = item.getAttribute('data-plain-media-id');
      var thumb = mediaId
        ? section.querySelector(
            '[data-buy-box-thumb][data-target-media-id="' + mediaId + '"]'
          )
        : null;

      item.setAttribute('data-media-flavor', parsedAlt.flavor);

      images.forEach(function (image) {
        var imageAlt = parseFlavorAltText(image.getAttribute('alt'));

        if (imageAlt.tagged) {
          image.setAttribute('alt', imageAlt.cleanAlt);
        }
      });

      if (!thumb) return;

      thumb.setAttribute('data-media-flavor', parsedAlt.flavor);

      qsa('img[alt]', thumb).forEach(function (image) {
        var imageAlt = parseFlavorAltText(image.getAttribute('alt'));

        if (imageAlt.tagged) {
          image.setAttribute('alt', imageAlt.cleanAlt);
        }
      });
    });

  }

  function variantIdsFor(item) {
    return String(item.getAttribute('data-variant-ids') || '')
      .split(',')
      .filter(Boolean);
  }

  function isVisibleForVariant(item, variantId) {
    var ids = variantIdsFor(item);

    if (!ids.length || !variantId) return true;

    return ids.indexOf(String(variantId)) !== -1;
  }

  function mediaMatchesFlavor(item, filterFlavor) {
    if (!filterFlavor) return true;

    var mediaFlavor = normalizeHandle(
      item.getAttribute('data-media-flavor')
    ) || SHARED_FLAVOR;

    return (
      mediaFlavor === SHARED_FLAVOR ||
      mediaFlavor === filterFlavor
    );
  }

  function hasDedicatedFlavorMedia(section, flavor) {
    if (!flavor) return false;

    return qsa('[data-buy-box-media]', section).some(function (item) {
      return (
        normalizeHandle(item.getAttribute('data-media-flavor')) === flavor
      );
    });
  }

  function usesDynamicFlavorGallery(section) {
    return getFlavorOptionIndex(section) >= 0;
  }

  function shouldFilterByVariant(section) {
    return (
      !usesDynamicFlavorGallery(section) &&
      section.getAttribute('data-active-variant-only') === 'true'
    );
  }

  function isMediaVisible(section, item, variantId, filterFlavor) {
    if (!mediaMatchesFlavor(item, filterFlavor)) {
      return false;
    }

    if (!shouldFilterByVariant(section)) {
      return true;
    }

    return isVisibleForVariant(item, variantId);
  }

  function getFlavorState(section, variant) {
    var flavor = getVariantFlavor(section, variant);
    var filterFlavor = hasDedicatedFlavorMedia(section, flavor)
      ? flavor
      : '';

    return {
      flavor: flavor,
      filterFlavor: filterFlavor
    };
  }

  function getLightbox(section) {
    return (
      section.__productBuyBoxLightbox ||
      section.querySelector('[data-buy-box-lightbox]')
    );
  }

  function getActiveZoomImage(section) {
    var activeItem = section.querySelector(
      '[data-buy-box-media].is-active:not([hidden])'
    );

    if (!activeItem) return null;

    var imageOpener = activeItem.querySelector(
      '.product__modal-opener--image'
    );

    if (!imageOpener) return null;

    return imageOpener.querySelector('img');
  }

  function openLightbox(section) {
    var lightbox = getLightbox(section);
    var lightboxImage = lightbox
      ? lightbox.querySelector('[data-buy-box-lightbox-image]')
      : null;
    var sourceImage = getActiveZoomImage(section);

    if (!lightbox || !lightboxImage || !sourceImage) return;

    lightboxImage.src =
      sourceImage.currentSrc ||
      sourceImage.getAttribute('src') ||
      '';

    lightboxImage.alt =
      sourceImage.getAttribute('alt') || '';

    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add(
      'product-buy-box-lightbox-open'
    );

    var closeButton = lightbox.querySelector(
      '.product-buy-box__lightbox-close'
    );

    if (closeButton) {
      window.requestAnimationFrame(function () {
        closeButton.focus();
      });
    }
  }

  function closeLightbox(section) {
    var lightbox = getLightbox(section);
    var lightboxImage = lightbox
      ? lightbox.querySelector('[data-buy-box-lightbox-image]')
      : null;

    if (!lightbox || lightbox.hidden) return;

    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove(
      'product-buy-box-lightbox-open'
    );

    if (lightboxImage) {
      lightboxImage.removeAttribute('src');
      lightboxImage.alt = '';
    }

    var activeItem = section.querySelector(
      '[data-buy-box-media].is-active:not([hidden])'
    );

    var zoomButton = activeItem
      ? activeItem.querySelector('.product__media-toggle')
      : null;

    if (zoomButton) {
      zoomButton.focus();
    }
  }

  function initLightbox(section) {
    var stage = section.querySelector(
      '.product-buy-box__media-stage'
    );

    var lightbox = section.querySelector(
      '[data-buy-box-lightbox]'
    );

    if (!stage || !lightbox) return;

    var sectionId =
      section.getAttribute('data-section-id') || '';

    var previousLightbox = sectionId
      ? document.body.querySelector(
          '[data-buy-box-lightbox-section="' +
            sectionId +
            '"]'
        )
      : null;

    if (
      previousLightbox &&
      previousLightbox !== lightbox
    ) {
      previousLightbox.remove();
    }

    lightbox.setAttribute(
      'data-buy-box-lightbox-section',
      sectionId
    );

    section.__productBuyBoxLightbox = lightbox;
    document.body.appendChild(lightbox);

    stage.addEventListener(
      'click',
      function (event) {
        var activeItem = section.querySelector(
          '[data-buy-box-media].is-active:not([hidden])'
        );

        var clickedZoomIcon = event.target.closest(
          '.product-buy-box__zoom-icon'
        );

        if (
          !activeItem ||
          (
            !activeItem.contains(event.target) &&
            !clickedZoomIcon
          ) ||
          !activeItem.querySelector(
            '.product__modal-opener--image'
          )
        ) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        openLightbox(section);
      },
      true
    );

    qsa(
      '[data-buy-box-lightbox-close]',
      lightbox
    ).forEach(function (button) {
      button.addEventListener('click', function () {
        closeLightbox(section);
      });
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          !lightbox.hidden
        ) {
          closeLightbox(section);
        }
      }
    );
  }

  function updatePrice(section, price, comparePrice) {
    var priceEl = section.querySelector('[data-buy-box-price-current]');
    var compareEl = section.querySelector('[data-buy-box-price-compare]');

    if (priceEl) {
      priceEl.textContent = money(price);
    }

    if (!compareEl) return;

    if (comparePrice && cents(comparePrice) > cents(price)) {
      compareEl.textContent = money(comparePrice);
      compareEl.hidden = false;
    } else {
      compareEl.textContent = '';
      compareEl.hidden = true;
    }
  }

  function getMediaImage(item) {
    if (!item) return null;

    return (
      item.querySelector('.product__modal-opener img') ||
      item.querySelector('img')
    );
  }

  function primeMediaImage(item, priority) {
    var image = getMediaImage(item);

    if (!image) return null;

    image.loading = 'eager';
    image.decoding = 'async';

    if ('fetchPriority' in image) {
      image.fetchPriority = priority || 'auto';
    }

    return image;
  }

  function waitForMediaImage(item, callback) {
    var image = primeMediaImage(item, 'high');

    if (
      !image ||
      (
        image.complete &&
        image.naturalWidth > 0
      )
    ) {
      callback();
      return;
    }

    var completed = false;
    var timeoutId = null;

    function finish() {
      if (completed) return;

      completed = true;

      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);

      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }

      callback();
    }

    image.addEventListener('load', finish);
    image.addEventListener('error', finish);

    if (typeof image.decode === 'function') {
      image.decode().then(finish).catch(function () {
        /*
         * The load/error listeners remain active when
         * decoding is not available yet.
         */
      });
    }

    timeoutId = window.setTimeout(
      finish,
      3000
    );
  }

  function removeMediaSnapshot(section) {
    var snapshot = section.querySelector(
      '[data-buy-box-media-snapshot]'
    );

    if (snapshot) {
      snapshot.remove();
    }

    if (section.__productBuyBoxSnapshotTimer) {
      window.clearTimeout(
        section.__productBuyBoxSnapshotTimer
      );

      section.__productBuyBoxSnapshotTimer = null;
    }
  }

  function createMediaSnapshot(section, activeItem) {
    var stage = section.querySelector(
      '.product-buy-box__media-stage'
    );

    var sourceImage = getMediaImage(activeItem);

    var sourceUrl = sourceImage
      ? (
          sourceImage.currentSrc ||
          sourceImage.getAttribute('src') ||
          ''
        )
      : '';

    removeMediaSnapshot(section);

    if (!stage || !sourceUrl) return null;

    var snapshot = document.createElement('img');

    snapshot.className =
      'product-buy-box__media-snapshot';

    snapshot.setAttribute(
      'data-buy-box-media-snapshot',
      ''
    );

    snapshot.setAttribute(
      'aria-hidden',
      'true'
    );

    snapshot.alt = '';
    snapshot.src = sourceUrl;

    stage.appendChild(snapshot);

    return snapshot;
  }

  function fadeMediaSnapshot(section, snapshot) {
    if (!snapshot) return;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        snapshot.classList.add('is-fading');
      });
    });

    section.__productBuyBoxSnapshotTimer =
      window.setTimeout(function () {
        if (snapshot.parentNode) {
          snapshot.remove();
        }

        section.__productBuyBoxSnapshotTimer = null;
      }, 380);
  }

  function setActiveMedia(
    section,
    mediaId,
    variantId,
    variant,
    preferFlavorMedia
  ) {
    var mediaItems = qsa('[data-buy-box-media]', section);
    var thumbs = qsa('[data-buy-box-thumb]', section);
    var flavorState = getFlavorState(section, variant);
    var filterFlavor = flavorState.filterFlavor;
    var target = null;

    closeLightbox(section);

    if (flavorState.flavor) {
      section.setAttribute(
        'data-active-media-flavor',
        flavorState.flavor
      );
    } else {
      section.removeAttribute('data-active-media-flavor');
    }

    /*
     * When the variant changes and dedicated flavor media exists,
     * automatically show the first image assigned to that flavor.
     *
     * Thumbnail clicks do not use this preference, so customers can
     * still manually select any visible shared or matching media.
     */
    if (preferFlavorMedia && filterFlavor) {
      target = mediaItems.find(function (item) {
        var mediaFlavor = normalizeHandle(
          item.getAttribute('data-media-flavor')
        );

        return (
          mediaFlavor === filterFlavor &&
          isMediaVisible(
            section,
            item,
            variantId,
            filterFlavor
          )
        );
      }) || null;
    }

    if (!target && mediaId) {
      target = section.querySelector(
        '[data-buy-box-media][data-plain-media-id="' +
          mediaId +
          '"]'
      );
    }

    if (
      target &&
      !isMediaVisible(
        section,
        target,
        variantId,
        filterFlavor
      )
    ) {
      target = null;
    }

    if (!target && filterFlavor) {
      target = mediaItems.find(function (item) {
        return (
          normalizeHandle(
            item.getAttribute('data-media-flavor')
          ) === filterFlavor &&
          isMediaVisible(
            section,
            item,
            variantId,
            filterFlavor
          )
        );
      }) || null;
    }

    if (!target && shouldFilterByVariant(section)) {
      target = mediaItems.find(function (item) {
        return (
          item.getAttribute('data-variant-ids') &&
          isMediaVisible(
            section,
            item,
            variantId,
            filterFlavor
          )
        );
      }) || null;
    }

    if (!target) {
      target = mediaItems.find(function (item) {
        return isMediaVisible(
          section,
          item,
          variantId,
          filterFlavor
        );
      }) || null;
    }

    if (!target) return;

    /*
     * Start loading the images belonging to the current
     * filtered gallery. The selected image gets priority.
     */
    mediaItems.forEach(function (item) {
      if (
        isMediaVisible(
          section,
          item,
          variantId,
          filterFlavor
        )
      ) {
        primeMediaImage(
          item,
          item === target ? 'high' : 'low'
        );
      }
    });

    section.__productBuyBoxMediaRequest =
      (section.__productBuyBoxMediaRequest || 0) + 1;

    var requestId =
      section.__productBuyBoxMediaRequest;

    var currentActive = section.querySelector(
      '[data-buy-box-media].is-active:not([hidden])'
    );

    function applyMediaSelection() {
      if (
        requestId !==
        section.__productBuyBoxMediaRequest
      ) {
        return;
      }

      var shouldAnimate = (
        currentActive &&
        currentActive !== target &&
        !window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      );

      /*
       * Keep a visual copy of the outgoing image over
       * the gallery while the new image fades in below.
       */
      var snapshot = shouldAnimate
        ? createMediaSnapshot(
            section,
            currentActive
          )
        : null;

      if (!shouldAnimate) {
        removeMediaSnapshot(section);
      }

      if (section.__productBuyBoxMediaTimer) {
        window.clearTimeout(
          section.__productBuyBoxMediaTimer
        );

        section.__productBuyBoxMediaTimer = null;
      }

      mediaItems.forEach(function (item) {
        var isVisible = isMediaVisible(
          section,
          item,
          variantId,
          filterFlavor
        );

        item.classList.remove(
          'is-active',
          'is-entering'
        );

        item.hidden = !isVisible;

        item.setAttribute(
          'aria-hidden',
          isVisible ? 'false' : 'true'
        );
      });

      /*
       * Force the new media into layout before adding
       * is-entering so the animation always restarts.
       */
      target.hidden = false;
      void target.offsetWidth;

      target.classList.add('is-active');

      if (shouldAnimate) {
        target.classList.add('is-entering');

        section.__productBuyBoxMediaTimer =
          window.setTimeout(function () {
            target.classList.remove(
              'is-entering'
            );

            section.__productBuyBoxMediaTimer = null;
          }, 340);

        fadeMediaSnapshot(
          section,
          snapshot
        );
      }

      var activeMediaId = target.getAttribute(
        'data-plain-media-id'
      );

      thumbs.forEach(function (thumb) {
        var thumbMediaId = thumb.getAttribute(
          'data-target-media-id'
        );

        var matchingMedia = section.querySelector(
          '[data-buy-box-media][data-plain-media-id="' +
            thumbMediaId +
            '"]'
        );

        var isVisible = (
          !matchingMedia ||
          isMediaVisible(
            section,
            matchingMedia,
            variantId,
            filterFlavor
          )
        );

        var isActive = (
          isVisible &&
          thumbMediaId === activeMediaId
        );

        thumb.classList.toggle(
          'is-active',
          isActive
        );

        thumb.hidden = !isVisible;

        thumb.setAttribute(
          'aria-hidden',
          isVisible ? 'false' : 'true'
        );

        if (
          isActive &&
          typeof thumb.scrollIntoView === 'function'
        ) {
          thumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });
    }

    /*
     * Do not remove the outgoing image until the next
     * image has loaded and decoded.
     */
    if (currentActive === target) {
      applyMediaSelection();
    } else {
      waitForMediaImage(
        target,
        applyMediaSelection
      );
    }
  }

  function getAvailabilityLabel(section, key, fallback) {
    return section.getAttribute('data-' + key + '-label') || fallback;
  }

  function setAvailabilityState(section, variant) {
    var isAvailable = !!(variant && variant.available);
    var variantId = variant && variant.id
      ? String(variant.id)
      : '';

    var button = section.querySelector('[name="add"]');

    var buttonText = button
      ? button.querySelector('[data-buy-box-submit-text]') ||
        button.querySelector('span')
      : null;

    var buttonLabel = isAvailable
      ? getAvailabilityLabel(
          section,
          'add-to-cart',
          'Add to cart'
        )
      : getAvailabilityLabel(
          section,
          variant ? 'sold-out' : 'unavailable',
          variant ? 'Sold out' : 'Unavailable'
        );

    section.setAttribute(
      'data-current-variant-id',
      variantId
    );

    section.setAttribute(
      'data-current-variant-available',
      isAvailable ? 'true' : 'false'
    );

    /*
     * Notify transition listeners need to capture the
     * app-generated button before the variant input
     * events cause the app to remove or replace it.
     */
    document.dispatchEvent(
      new CustomEvent(
        'product-buy-box:availability-before-change',
        {
          detail: {
            section: section,
            sectionId: section.getAttribute(
              'data-section-id'
            ),
            variantId: variantId,
            available: isAvailable
          }
        }
      )
    );

    qsa(
      '[data-buy-box-variant-input], ' +
      '#product-form-installment [name="id"]',
      section
    ).forEach(function (input) {
      if (!variantId) return;

      var valueChanged =
        String(input.value || '') !== variantId;

      input.value = variantId;

      /*
       * Back-in-stock apps commonly read the product
       * form variant ID from native input/change events.
       * Emit both immediately after the ID is updated so
       * they receive the newly selected variant, not the
       * previously selected one.
       */
      if (
        valueChanged &&
        input.matches('[data-buy-box-variant-input]')
      ) {
        input.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        input.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });

    if (button) {
      button.disabled = !isAvailable;

      if (isAvailable) {
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('aria-disabled', 'true');
      }
    }

    if (buttonText) {
      buttonText.textContent = buttonLabel;
    }

    qsa('[data-buy-box-quantity]', section).forEach(function (stepper) {
      stepper.classList.toggle(
        'is-disabled',
        !isAvailable
      );

      if (isAvailable) {
        stepper.removeAttribute('aria-disabled');
      } else {
        stepper.setAttribute('aria-disabled', 'true');
      }

      qsa('button, input', stepper).forEach(function (control) {
        control.disabled = !isAvailable;
      });
    });

    qsa('[data-buy-box-available-only]', section).forEach(function (element) {
      element.hidden = !isAvailable;
    });
  }

  function dispatchVariantChange(section, variant) {
    window.setTimeout(function () {
      document.dispatchEvent(
        new CustomEvent('product-buy-box:variant-change', {
          detail: {
            sectionId: section.getAttribute('data-section-id'),
            variant: variant || null,
            available: !!(variant && variant.available)
          }
        })
      );
    }, 0);
  }

  function initQuantity(section) {
    qsa('[data-buy-box-quantity]', section).forEach(function (stepper) {
      var input = stepper.querySelector('[name="quantity"]');
      var decrease = stepper.querySelector(
        '[data-quantity-decrease]'
      );
      var increase = stepper.querySelector(
        '[data-quantity-increase]'
      );

      if (!input || !decrease || !increase) return;

      function normalize(value) {
        var min = parseInt(
          input.getAttribute('min') || '1',
          10
        );

        var quantity = parseInt(value, 10);

        if (!Number.isFinite(quantity)) {
          quantity = min;
        }

        return Math.max(min, quantity);
      }

      function setQuantity(value) {
        input.value = normalize(value);

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      decrease.addEventListener('click', function () {
        setQuantity(normalize(input.value) - 1);
      });

      increase.addEventListener('click', function () {
        setQuantity(normalize(input.value) + 1);
      });

      input.addEventListener('change', function () {
        input.value = normalize(input.value);
      });
    });
  }

  function getSubscriptionMediaMap(section) {
    if (section.__productBuyBoxSubscriptionMediaMap) {
      return section.__productBuyBoxSubscriptionMediaMap;
    }

    var mappings = parseJSON(
      section.querySelector(
        '[data-buy-box-subscription-media-map]'
      )
    );

    var mediaMap = {};

    if (Array.isArray(mappings)) {
      mappings.forEach(function (mapping) {
        var flavor = normalizeHandle(
          mapping && mapping.flavor
        );

        var mediaId = mapping && mapping.mediaId
          ? String(mapping.mediaId)
          : '';

        if (flavor && mediaId) {
          mediaMap[flavor] = mediaId;
        }
      });
    }

    section.__productBuyBoxSubscriptionMediaMap =
      mediaMap;

    return mediaMap;
  }

  function getSubscriptionMediaId(
    section,
    variant
  ) {
    var flavor = getVariantFlavor(
      section,
      variant
    );

    if (!flavor) return '';

    return (
      getSubscriptionMediaMap(section)[flavor] ||
      ''
    );
  }

  function getOnetimeMediaId(
    section,
    variant,
    subscriptionMediaId
  ) {
    var mediaItems = qsa(
      '[data-buy-box-media]',
      section
    );

    var flavorState = getFlavorState(
      section,
      variant
    );

    var filterFlavor =
      flavorState.filterFlavor;

    var featuredMediaId = (
      variant &&
      variant.featured_media &&
      variant.featured_media.id
    )
      ? String(variant.featured_media.id)
      : '';

    function isEligible(item) {
      if (!item) return false;

      var mediaId = item.getAttribute(
        'data-plain-media-id'
      );

      return (
        mediaId !== subscriptionMediaId &&
        isMediaVisible(
          section,
          item,
          variant ? variant.id : null,
          filterFlavor
        )
      );
    }

    if (
      featuredMediaId &&
      featuredMediaId !== subscriptionMediaId
    ) {
      var featuredMedia = section.querySelector(
        '[data-buy-box-media][data-plain-media-id="' +
          featuredMediaId +
          '"]'
      );

      if (isEligible(featuredMedia)) {
        return featuredMediaId;
      }
    }

    /*
     * Prefer the first non-subscription image explicitly
     * assigned to the currently selected flavor.
     */
    var flavorMedia = mediaItems.find(
      function (item) {
        return (
          normalizeHandle(
            item.getAttribute(
              'data-media-flavor'
            )
          ) === flavorState.flavor &&
          isEligible(item)
        );
      }
    );

    if (flavorMedia) {
      return flavorMedia.getAttribute(
        'data-plain-media-id'
      );
    }

    /*
     * Final fallback: first visible gallery image that
     * is not the mapped subscription image.
     */
    var firstVisibleMedia = mediaItems.find(
      isEligible
    );

    return firstVisibleMedia
      ? firstVisibleMedia.getAttribute(
          'data-plain-media-id'
        )
      : '';
  }

  function syncPurchaseMedia(
    section,
    purchaseType
  ) {
    if (
      purchaseType !== 'subscription' &&
      purchaseType !== 'onetime'
    ) {
      return;
    }

    var variant = findVariant(section);

    if (!variant) return;

    var flavor = getVariantFlavor(
      section,
      variant
    );

    var stateKey = [
      purchaseType,
      flavor,
      variant.id
    ].join('|');

    /*
     * Do not force the assigned image again when only
     * subscription frequency or displayed pricing changes.
     * Re-run only when purchase type, flavor, or variant
     * changes.
     */
    if (
      section.__productBuyBoxPurchaseMediaKey ===
      stateKey
    ) {
      return;
    }

    section.__productBuyBoxPurchaseMediaKey =
      stateKey;

    var subscriptionMediaId =
      getSubscriptionMediaId(
        section,
        variant
      );

    if (purchaseType === 'subscription') {
      if (!subscriptionMediaId) return;

      setActiveMedia(
        section,
        subscriptionMediaId,
        variant.id,
        variant,
        false
      );

      return;
    }

    var onetimeMediaId = getOnetimeMediaId(
      section,
      variant,
      subscriptionMediaId
    );

    if (!onetimeMediaId) return;

    setActiveMedia(
      section,
      onetimeMediaId,
      variant.id,
      variant,
      false
    );
  }

  function syncVariant(section) {
    var variant = findVariant(section);

    if (!variant) {
      setAvailabilityState(section, null);
      dispatchVariantChange(section, null);
      return;
    }

    var featuredMediaId = (
      variant.featured_media &&
      variant.featured_media.id
    )
      ? String(variant.featured_media.id)
      : null;

    setActiveMedia(
      section,
      featuredMediaId,
      variant.id,
      variant,
      true
    );

    if (!section.getAttribute('data-skio-price-active')) {
      updatePrice(
        section,
        variant.price,
        variant.compare_at_price
      );
    }

    setAvailabilityState(section, variant);
    dispatchVariantChange(section, variant);
  }

  function init(section) {
    if (
      section.getAttribute(
        'data-product-buy-box-initialized'
      ) === 'true'
    ) {
      return;
    }

    section.setAttribute(
      'data-product-buy-box-initialized',
      'true'
    );

    prepareFlavorMedia(section);
    initQuantity(section);
    initLightbox(section);
    initBogoSubmission(section);

    qsa('[data-buy-box-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var variant = findVariant(section);

        setActiveMedia(
          section,
          thumb.getAttribute('data-target-media-id'),
          variant ? variant.id : null,
          variant,
          false
        );
      });
    });

    var variants = section.querySelector(
      'variant-radios, variant-selects'
    );

    if (variants) {
      variants.addEventListener('change', function () {
        /*
         * A radio/select change already has its new value
         * when this handler runs. Sync immediately so app
         * listeners higher in the DOM see the correct
         * variant ID during the same change event.
         */
        syncVariant(section);
      });

      syncVariant(section);
    } else {
      var variant = findVariant(section);

      setActiveMedia(
        section,
        variant &&
          variant.featured_media &&
          variant.featured_media.id
          ? String(variant.featured_media.id)
          : null,
        variant ? variant.id : section.getAttribute(
          'data-current-variant-id'
        ),
        variant,
        true
      );
    }
  }

  function initializeProductBuyBoxes(scope) {
    var root = scope || document;
    var sections = [];

    if (
      root.matches &&
      root.matches('[data-product-buy-box]')
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(
        qsa('[data-product-buy-box]', root)
      );
    }

    var bogoSection = sections.find(function (section) {
      return !!getActiveBogoParams(section);
    });

    if (
      bogoSection &&
      applyBogoUrlParams(
        bogoSection,
        { allowReload: true }
      )
    ) {
      return;
    }

    sections.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeProductBuyBoxes(document);
      }
    );
  } else {
    initializeProductBuyBoxes(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeProductBuyBoxes(event.target);
    }
  );

  document.addEventListener(
    'skio-subscriptions:price-change',
    function (event) {
      var detail = event.detail || {};

      if (!detail.formId) return;

      var section = document.getElementById(detail.formId);

      section = section
        ? section.closest('[data-product-buy-box]')
        : null;

      if (!section) return;

      section.setAttribute(
        'data-skio-price-active',
        'true'
      );

      updatePrice(
        section,
        detail.price,
        detail.comparePrice
      );

      syncPurchaseMedia(
        section,
        detail.purchaseType
      );
    }
  );
})();

(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-product-buy-box]';

  function qsa(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }

  function getVisibleThumbs(section) {
    return qsa(
      '[data-buy-box-thumb]:not([hidden])',
      section
    );
  }

  function updateGalleryButtons(section) {
    var visibleThumbs = getVisibleThumbs(section);

    var previousButton = section.querySelector(
      '[data-buy-box-gallery-previous]'
    );

    var nextButton = section.querySelector(
      '[data-buy-box-gallery-next]'
    );

    var shouldHide = visibleThumbs.length < 2;

    if (previousButton) {
      previousButton.hidden = shouldHide;
      previousButton.disabled = shouldHide;
    }

    if (nextButton) {
      nextButton.hidden = shouldHide;
      nextButton.disabled = shouldHide;
    }
  }

  function moveGallery(section, direction) {
    var visibleThumbs = getVisibleThumbs(section);

    if (visibleThumbs.length < 2) return;

    var activeIndex = visibleThumbs.findIndex(
      function (thumb) {
        return thumb.classList.contains(
          'is-active'
        );
      }
    );

    if (activeIndex < 0) {
      activeIndex = 0;
    }

    var targetIndex = (
      activeIndex +
      direction +
      visibleThumbs.length
    ) % visibleThumbs.length;

    /*
     * Use the existing thumbnail listener so the
     * active image, active thumbnail, flavor filter,
     * thumbnail scrolling, and lightbox stay synced.
     */
    visibleThumbs[targetIndex].click();
  }

  function suppressNextStageClick(stage) {
    var timeoutId = null;

    function cleanup() {
      document.removeEventListener(
        'click',
        blockClick,
        true
      );

      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    }

    function blockClick(event) {
      if (!stage.contains(event.target)) return;

      /*
       * Mobile browsers fire a click after touchend.
       * Block that single click so a swipe does not
       * also open the zoom lightbox.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      cleanup();
    }

    document.addEventListener(
      'click',
      blockClick,
      true
    );

    timeoutId = window.setTimeout(
      cleanup,
      700
    );
  }

  function initGalleryEnhancements(section) {
    if (
      section.getAttribute(
        'data-buy-box-gallery-enhanced'
      ) === 'true'
    ) {
      return;
    }

    var stage = section.querySelector(
      '.product-buy-box__media-stage'
    );

    var thumbs = section.querySelector(
      '.product-buy-box__thumbs'
    );

    var previousButton = section.querySelector(
      '[data-buy-box-gallery-previous]'
    );

    var nextButton = section.querySelector(
      '[data-buy-box-gallery-next]'
    );

    if (
      !stage ||
      !thumbs ||
      !previousButton ||
      !nextButton
    ) {
      return;
    }

    section.setAttribute(
      'data-buy-box-gallery-enhanced',
      'true'
    );

    previousButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        moveGallery(section, -1);
      }
    );

    nextButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        moveGallery(section, 1);
      }
    );

    var touchStartX = 0;
    var touchStartY = 0;
    var trackingTouch = false;

    stage.addEventListener(
      'touchstart',
      function (event) {
        if (
          !window.matchMedia(
            '(max-width: 749px)'
          ).matches ||
          event.touches.length !== 1
        ) {
          trackingTouch = false;
          return;
        }

        touchStartX =
          event.touches[0].clientX;

        touchStartY =
          event.touches[0].clientY;

        trackingTouch = true;
      },
      {
        passive: true
      }
    );

    stage.addEventListener(
      'touchend',
      function (event) {
        if (
          !trackingTouch ||
          event.changedTouches.length !== 1
        ) {
          trackingTouch = false;
          return;
        }

        var deltaX =
          event.changedTouches[0].clientX -
          touchStartX;

        var deltaY =
          event.changedTouches[0].clientY -
          touchStartY;

        trackingTouch = false;

        /*
         * Require a clear horizontal swipe so normal
         * taps and vertical page scrolling are ignored.
         */
        if (
          Math.abs(deltaX) < 45 ||
          Math.abs(deltaX) <=
            Math.abs(deltaY) * 1.15
        ) {
          return;
        }

        suppressNextStageClick(stage);

        moveGallery(
          section,
          deltaX < 0 ? 1 : -1
        );
      },
      {
        passive: true
      }
    );

    stage.addEventListener(
      'touchcancel',
      function () {
        trackingTouch = false;
      },
      {
        passive: true
      }
    );

    /*
     * The main gallery script updates thumbnail
     * hidden and active states whenever variants,
     * flavors, or images change.
     */
    var observer = new MutationObserver(
      function () {
        updateGalleryButtons(section);
      }
    );

    observer.observe(thumbs, {
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'hidden',
        'aria-hidden'
      ]
    });

    updateGalleryButtons(section);
  }

  function initializeGalleryEnhancements(scope) {
    var root = scope || document;
    var sections = [];

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(
        qsa(SECTION_SELECTOR, root)
      );
    }

    sections.forEach(
      initGalleryEnhancements
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeGalleryEnhancements(
          document
        );
      }
    );
  } else {
    initializeGalleryEnhancements(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeGalleryEnhancements(
        event.target
      );
    }
  );
})();

(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-product-buy-box]';

  function qsa(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }

  function getConfiguredStickerMediaIds(section) {
    if (section.__productBuyBoxCcStickerMediaIds) {
      return section.__productBuyBoxCcStickerMediaIds;
    }

    var script = section.querySelector(
      '[data-buy-box-cc-sticker-media-ids]'
    );

    var mediaIds = [];

    if (script) {
      try {
        var parsed = JSON.parse(
          script.textContent
        );

        if (Array.isArray(parsed)) {
          mediaIds = parsed
            .map(function (mediaId) {
              return String(mediaId || '');
            })
            .filter(Boolean);
        }
      } catch (error) {
        console.warn(
          'Product Buy Box: invalid Clinicians Choice media IDs.',
          error
        );
      }
    }

    section.__productBuyBoxCcStickerMediaIds =
      mediaIds;

    return mediaIds;
  }

  function updateCliniciansChoiceSticker(section) {
    var sticker = section.querySelector(
      '[data-clinicians-choice-sticker]'
    );

    if (!sticker) return;

    var visibleMedia = qsa(
      '[data-buy-box-media]:not([hidden])',
      section
    );

    var activeMedia = section.querySelector(
      '[data-buy-box-media].is-active:not([hidden])'
    );

    var configuredMediaIds =
      getConfiguredStickerMediaIds(section);

    var activeMediaId = activeMedia
      ? activeMedia.getAttribute(
          'data-plain-media-id'
        )
      : '';

    /*
     * Once one or more CC sticker image blocks are
     * configured, show the sticker only on those media
     * IDs. Until then, preserve the original first
     * visible image behavior.
     */
    var shouldShowSticker =
      configuredMediaIds.length > 0
        ? configuredMediaIds.indexOf(
            String(activeMediaId || '')
          ) !== -1
        : (
            visibleMedia.length > 0 &&
            activeMedia === visibleMedia[0]
          );

    sticker.classList.toggle(
      'is-visible',
      shouldShowSticker
    );

    sticker.classList.toggle(
      'is-hidden',
      !shouldShowSticker
    );

    sticker.setAttribute(
      'aria-hidden',
      shouldShowSticker ? 'false' : 'true'
    );
  }

  function initCliniciansChoiceSticker(section) {
    if (
      section.getAttribute(
        'data-buy-box-cc-sticker-initialized'
      ) === 'true'
    ) {
      return;
    }

    var sticker = section.querySelector(
      '[data-clinicians-choice-sticker]'
    );

    var stage = section.querySelector(
      '.product-buy-box__media-stage'
    );

    if (!sticker || !stage) return;

    section.setAttribute(
      'data-buy-box-cc-sticker-initialized',
      'true'
    );

    var observer = new MutationObserver(
      function () {
        updateCliniciansChoiceSticker(section);
      }
    );

    observer.observe(stage, {
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'hidden',
        'aria-hidden'
      ]
    });

    updateCliniciansChoiceSticker(section);
  }

  function initializeCliniciansChoiceStickers(scope) {
    var root = scope || document;
    var sections = [];

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(
        qsa(SECTION_SELECTOR, root)
      );
    }

    sections.forEach(
      initCliniciansChoiceSticker
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeCliniciansChoiceStickers(
          document
        );
      }
    );
  } else {
    initializeCliniciansChoiceStickers(
      document
    );
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeCliniciansChoiceStickers(
        event.target
      );
    }
  );
})();

(function () {
  'use strict';

  var SECTION_SELECTOR =
    '[data-product-buy-box]';

  var CONTROL_SELECTOR = [
    'button',
    'a',
    '[role="button"]',
    'input[type="button"]',
    'input[type="submit"]'
  ].join(',');

  var NOTIFY_TEXT_PATTERN =
    /notify\s*me(?:\s*when\s*available)?|back\s*in\s*stock/i;

  function qsa(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(
        selector
      )
    );
  }

  function prefersReducedMotion() {
    return window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
  }

  function getControlText(control) {
    if (!control) return '';

    return [
      control.textContent || '',
      control.value || '',
      control.getAttribute('aria-label') || '',
      control.getAttribute('title') || ''
    ].join(' ').replace(/\s+/g, ' ').trim();
  }

  function findNotifyControl(section) {
    return qsa(
      CONTROL_SELECTOR,
      section
    ).find(function (control) {
      return (
        !control.classList.contains(
          'product-buy-box__notify-exit-clone'
        ) &&
        NOTIFY_TEXT_PATTERN.test(
          getControlText(control)
        )
      );
    }) || null;
  }

  function isControlVisible(control) {
    if (
      !control ||
      !control.isConnected ||
      !control.getClientRects().length
    ) {
      return false;
    }

    var styles =
      window.getComputedStyle(control);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden'
    );
  }

  function getNotifyHost(control) {
    if (!control) return null;

    return (
      control.closest(
        '.product-buy-box__app-block'
      ) ||
      control
    );
  }

  function clearHostAnimation(host) {
    if (!host) return;

    if (host.__pbbNotifyTimer) {
      window.clearTimeout(
        host.__pbbNotifyTimer
      );

      host.__pbbNotifyTimer = null;
    }

    host.classList.remove(
      'product-buy-box__notify-transition-host',
      'is-entering',
      'is-leaving'
    );

    host.style.removeProperty('height');
    host.style.removeProperty('opacity');
    host.style.removeProperty('overflow');
    host.style.removeProperty('transform');
    host.style.removeProperty('will-change');
  }

  function finishHostAnimation(
    host,
    duration
  ) {
    if (!host) return;

    if (host.__pbbNotifyTimer) {
      window.clearTimeout(
        host.__pbbNotifyTimer
      );
    }

    host.__pbbNotifyTimer =
      window.setTimeout(function () {
        clearHostAnimation(host);
      }, duration);
  }

  function animateNotifyEntry(control) {
    if (
      !control ||
      prefersReducedMotion()
    ) {
      return;
    }

    var host = getNotifyHost(control);

    if (!host) return;

    clearHostAnimation(host);

    var targetHeight = Math.ceil(
      Math.max(
        host.scrollHeight,
        host.getBoundingClientRect().height
      )
    );

    if (!targetHeight) return;

    host.classList.add(
      'product-buy-box__notify-transition-host',
      'is-entering'
    );

    host.style.height = '0px';
    host.style.opacity = '0';
    host.style.overflow = 'hidden';
    host.style.transform =
      'translate3d(0, -6px, 0)';
    host.style.willChange =
      'height, opacity, transform';

    /*
     * Force the collapsed state into layout before
     * transitioning to the button's full height.
     */
    void host.offsetHeight;

    window.requestAnimationFrame(function () {
      host.style.height =
        targetHeight + 'px';

      host.style.opacity = '1';

      host.style.transform =
        'translate3d(0, 0, 0)';
    });

    finishHostAnimation(host, 340);
  }

  function copyComputedButtonStyles(
    source,
    clone
  ) {
    var styles =
      window.getComputedStyle(source);

    clone.style.boxSizing =
      'border-box';

    clone.style.display =
      'flex';

    clone.style.alignItems =
      'center';

    clone.style.justifyContent =
      'center';

    clone.style.background =
      styles.background;

    clone.style.backgroundColor =
      styles.backgroundColor;

    clone.style.color =
      styles.color;

    clone.style.border =
      styles.border;

    clone.style.borderRadius =
      styles.borderRadius;

    clone.style.boxShadow =
      styles.boxShadow;

    clone.style.padding =
      styles.padding;

    clone.style.font =
      styles.font;

    clone.style.fontFamily =
      styles.fontFamily;

    clone.style.fontSize =
      styles.fontSize;

    clone.style.fontWeight =
      styles.fontWeight;

    clone.style.letterSpacing =
      styles.letterSpacing;

    clone.style.lineHeight =
      styles.lineHeight;

    clone.style.textAlign =
      styles.textAlign;

    clone.style.textTransform =
      styles.textTransform;

    clone.style.whiteSpace =
      styles.whiteSpace;
  }

  function createExitClone(control) {
    if (
      !control ||
      prefersReducedMotion()
    ) {
      return null;
    }

    var rect =
      control.getBoundingClientRect();

    if (
      rect.width <= 0 ||
      rect.height <= 0
    ) {
      return null;
    }

    var clone =
      control.cloneNode(true);

    clone.removeAttribute('id');
    clone.removeAttribute('name');

    clone.setAttribute(
      'aria-hidden',
      'true'
    );

    clone.setAttribute(
      'tabindex',
      '-1'
    );

    if ('disabled' in clone) {
      clone.disabled = true;
    }

    clone.classList.add(
      'product-buy-box__notify-exit-clone'
    );

    copyComputedButtonStyles(
      control,
      clone
    );

    clone.style.position = 'fixed';
    clone.style.left = rect.left + 'px';
    clone.style.top = rect.top + 'px';
    clone.style.width = rect.width + 'px';
    clone.style.height = rect.height + 'px';
    clone.style.margin = '0';
    clone.style.zIndex = '2147482000';
    clone.style.pointerEvents = 'none';

    document.body.appendChild(clone);

    window.requestAnimationFrame(function () {
      clone.classList.add(
        'is-leaving'
      );
    });

    window.setTimeout(function () {
      clone.remove();
    }, 340);

    return clone;
  }

  function animateNotifyExit(section) {
    if (
      !section ||
      prefersReducedMotion()
    ) {
      return;
    }

    var control =
      findNotifyControl(section);

    if (!isControlVisible(control)) {
      return;
    }

    var host = getNotifyHost(control);

    if (!host) return;

    createExitClone(control);
    clearHostAnimation(host);

    var currentHeight = Math.ceil(
      host.getBoundingClientRect().height
    );

    if (!currentHeight) return;

    host.classList.add(
      'product-buy-box__notify-transition-host',
      'is-leaving'
    );

    host.style.height =
      currentHeight + 'px';

    host.style.opacity = '1';
    host.style.overflow = 'hidden';
    host.style.transform =
      'translate3d(0, 0, 0)';
    host.style.willChange =
      'height, opacity, transform';

    void host.offsetHeight;

    window.requestAnimationFrame(function () {
      host.style.height = '0px';
      host.style.opacity = '0';

      host.style.transform =
        'translate3d(0, -6px, 0)';
    });

    finishHostAnimation(host, 340);
  }

  function syncNotifyState(section) {
    var control =
      findNotifyControl(section);

    var isVisible =
      isControlVisible(control);

    var state =
      section.__pbbNotifyTransitionState;

    if (!state) {
      section.__pbbNotifyTransitionState = {
        control: control,
        visible: isVisible
      };

      return;
    }

    if (
      isVisible &&
      (
        !state.visible ||
        state.control !== control
      )
    ) {
      animateNotifyEntry(control);
    }

    state.control = control;
    state.visible = isVisible;
  }

  function scheduleNotifySync(section) {
    if (
      section.__pbbNotifySyncFrame
    ) {
      return;
    }

    section.__pbbNotifySyncFrame =
      window.requestAnimationFrame(
        function () {
          section.__pbbNotifySyncFrame =
            null;

          syncNotifyState(section);
        }
      );
  }

  function initNotifyTransition(section) {
    if (
      section.getAttribute(
        'data-buy-box-notify-transition-initialized'
      ) === 'true'
    ) {
      return;
    }

    section.setAttribute(
      'data-buy-box-notify-transition-initialized',
      'true'
    );

    /*
     * Establish the initial state without animating
     * a button that was already visible on page load.
     */
    syncNotifyState(section);

    var observer = new MutationObserver(
      function () {
        scheduleNotifySync(section);
      }
    );

    observer.observe(section, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'hidden',
        'aria-hidden'
      ]
    });
  }

  function initializeNotifyTransitions(scope) {
    var root = scope || document;
    var sections = [];

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(
        qsa(SECTION_SELECTOR, root)
      );
    }

    sections.forEach(
      initNotifyTransition
    );
  }

  document.addEventListener(
    'product-buy-box:availability-before-change',
    function (event) {
      var detail = event.detail || {};
      var section = detail.section;

      /*
       * When the newly selected variant is available,
       * the Notify Me button is about to disappear.
       */
      if (
        section &&
        detail.available === true
      ) {
        animateNotifyExit(section);
      }
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeNotifyTransitions(
          document
        );
      }
    );
  } else {
    initializeNotifyTransitions(
      document
    );
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeNotifyTransitions(
        event.target
      );
    }
  );
})();